// import ImageSwiper from "components/ImageSwiper";
import { Link, useNavigate } from "react-router-dom";
import { getSettings } from "store/slices";
import { useAppSelector } from "store/hooks";
import { useEffect, useState } from "react";
import { t } from "i18next";
import { Divider, Input } from "antd";
import { useModal } from "context/hooks/useModal";
import OutlinedButton from "components/common/Button/OutlinedButton";
import Loader from "components/Loader";
import axiosInstance from "utils/axios";
import { useTenant } from "context/tenantProvider";
import { formatMessage, useSearch } from "utils/utility";
import { lifeChoiseDetailsDesktop } from "constantVariables";
import useMediaQuery from "hooks/useMediaQuery";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import GoogleRegister from "./GoogleRegister";
import { encrypt } from "utils/crypto";
import Google from "assets/icons/Google";
import RenderTermsAndPrivacy from "./RenderTermsAndPrivacy";
import PhoneIcon from "assets/icons/PhoneIcon";
import { sanitizeTextInput, validateTextareaInput } from "utils/security";

export function promiseModal(showModal, content, size = "md", closeModal, confirmButton, cancelButton, dir) {
  return new Promise((resolve) => {
    showModal(
      <div dir={dir}>
        {content}
        <div className="flex flex-col sm:flex-row gap-3 mt-8">
          <button
            className="bg-gradient-to-r from-amber-500 to-yellow-500 hover:from-amber-600 hover:to-yellow-600 text-gray-900 px-8 py-3 rounded-xl font-semibold transition-all duration-200 shadow-lg hover:shadow-xl flex-1 sm:flex-none sm:w-auto"
            onClick={() => {
              resolve(true);
              closeModal && closeModal();
            }}
          >
            {confirmButton}
          </button>
          <button
            className="border-2 border-gray-300 text-gray-700 hover:border-gray-400 hover:bg-gray-50 px-8 py-3 rounded-xl font-medium transition-all duration-200 flex-1 sm:flex-none sm:w-auto"
            onClick={() => {
              resolve(false);
              closeModal && closeModal();
            }}
          >
            {cancelButton || t("cancel")}
          </button>
        </div>
      </div>,
      size,
      null,
      null,
      // () => resolve(false)
    );
  });
}

export default function Register() {
  const { dir, tenant: tenantDetail } = useAppSelector(getSettings);
  const { showModal, hideModal } = useModal();
  const navigate = useNavigate();
  const [signUpWithEmail, setSignupWithEmail] = useState(false);

  const { tenant, isLoading: tenantLoading } = useTenant();

  const [inputVales, setInputValues] = useState({
    firstName: "",
    lastName: "",
    // email: "",
    phone_number: "",
    // password: "",
    // confirmPassword: "",
    error: "",
    notification: "",
    loading: false,
    termsAndPolicyChecked: false,
  });

  const queryDetails = useSearch();

  const isDesktop = useMediaQuery(lifeChoiseDetailsDesktop);

  useEffect(() => {
    if (!tenantLoading && tenant === "app") {
      navigate("/user-auth/login");
    }
  }, [tenant, tenantLoading]);

  async function handleSubmit() {
    // Sanitize and validate all inputs before processing
    const firstNameValidation = validateTextareaInput(inputVales.firstName, 50);
    const lastNameValidation = validateTextareaInput(inputVales.lastName, 50);
    
    if (!firstNameValidation.isValid || !lastNameValidation.isValid) {
      setInputValues({
        ...inputVales,
        error: "Invalid input detected. Please check your entries.",
      });
      return;
    }

    if (
      !inputVales.firstName.trim() ||
      !inputVales.lastName.trim() ||
      // !inputVales.email.trim() ||
      !inputVales.phone_number.trim()
      // !inputVales.password.trim() ||
      // !inputVales.confirmPassword.trim()
    ) {
      setInputValues({
        ...inputVales,
        error: t("registerFillAllFields"),
      });
      return;
    }

    // const emailRegex =
    //   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    // if (!emailRegex.test(inputVales.email)) {
    //   setInputValues({
    //     ...inputVales,
    //     error: t("registerInvalidEmail"),
    //   });
    //   return;
    // }

    // const inWhiteListEmailDomain = ["gmail.com", "outlook.com", "yahoo.com", "hotmail.com"].some(ele => inputVales.email.endsWith(ele))
    // if (!inWhiteListEmailDomain) {
    //   setInputValues({
    //     ...inputVales,
    //     error: t("emailDomainForbidden")
    //   })
    //   return;
    // }
    const phoneRegex =
      /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/;

    if (!phoneRegex.test(inputVales.phone_number)) {
      setInputValues({
        ...inputVales,
        error: t("registerPhoneInvalid"),
      });
      return;
    }

    const validPhoneRegex =
      /^05(0\d{3}\d{4}|1(2\d{2}|5\d{2})\d{4}|2\d{3}\d{4}|3\d{3}\d{4}|4\d{3}\d{4}|5(2\d{2}|33\d|32\d|440|441|410|442|43\d|5\d{2}|55\d|6\d{2}|7\d{2}|8\d{2}|9\d{2}|77\d)\d{4}|8\d{3}\d{4})$/;

    if (!validPhoneRegex.test(inputVales.phone_number)) {
      setInputValues({
        ...inputVales,
        error: t("phoneForbidden"),
      });
      return;
    }

    // if (inputVales.password !== inputVales.confirmPassword) {
    //   setInputValues({
    //     ...inputVales,
    //     error: t("registerPasswordAndConfirmPasswordMustBeSame"),
    //   });
    //   return;
    // }

    // // password should only be in english or numbers or special characters
    // const isPasswordValid = /^[a-zA-Z0-9!@#$%^&*()_+~`|}{[\]:;?><,./-]*$/.test(
    //   inputVales.password
    // );
    // if (!isPasswordValid) {
    //   setInputValues({
    //     ...inputVales,
    //     error: t("passwordEnglishRequirments"),
    //   });
    //   return;
    // }

    // const passwordRegex =
    // /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+~`|}{[\]:;?><,./-])(?=.*[a-zA-Z]).{8,50}$/;
    // if (!passwordRegex.test(inputVales.password)) {
    //   setInputValues({
    //     ...inputVales,
    //     error: t("passwordRequirments"),
    //   });
    //   return;
    // }

    if (!inputVales.termsAndPolicyChecked) {
      setInputValues({
        ...inputVales,
        error: t("registerAgreeToTerms"),
      });
      return;
    }

    let divur = false;

    if (tenantDetail.divur) {
      divur = await promiseModal(
        showModal,
        <div dir={dir} className="p-6">
          <div className="text-center mb-6">
            <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-gray-800 mb-3">{tenantDetail.divur.title}</h1>
            <p className="text-gray-600 leading-relaxed">{tenantDetail.divur.description}</p>
          </div>
          
          {tenantDetail.divur.terms.url ? (
            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
              <p className="text-sm text-gray-700 text-center">
                {tenantDetail.divur.terms.text}&nbsp;
                <a 
                  href={tenantDetail.divur.terms.url} 
                  className="text-blue-600 hover:text-blue-800 underline font-medium transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {tenantDetail.divur.terms.textLink}
                </a>
              </p>
            </div>
          ) : null}
        </div>,
        "xs",
        hideModal,
        tenantDetail.divur.confirmButton,
        tenantDetail.divur.cancelButton,
        dir
      );

    }

    //  showModal(
    //   <RenderTermsAndPrivacy url="https://link.nexme.ai/privacy" />,
    //   "md"
    // );

    setInputValues({
      ...inputVales,
      loading: true,
      error: "",
      notification: "",
    });
    const apiPayload = {
      first_name: firstNameValidation.sanitized,
      last_name: lastNameValidation.sanitized,
      divur,
      // email: inputVales.email,
      // password: inputVales.password,
      // confirm_password: inputVales.confirmPassword,
      phone_number: inputVales.phone_number, // Phone is already validated by regex
      quiz: localStorage.getItem("quiz"),
      queryDetails,
    };
    axiosInstance
      .post("users/register", { data: encrypt(apiPayload) })
      .then((res) => res.data)
      .then((data) => {
        if (data.statusCode === 201) {
          setInputValues({
            ...inputVales,
            notification: t("registerSuccessMessage"),
            error: "",
            loading: false,
          });
          // showModal(
          //   <div className="max-h-[90vh] md:max-h-[70vh] overflow-y-auto">
          //     <button
          //       className="rounded-full border border-black w-6 h-6"
          //       onClick={() => {
          //         hideModal();
          //         navigate("/user-auth/login");
          //       }}
          //     >
          //       X
          //     </button>
          //     <p className="text-center mt-5">{t("registerSuccessMessage")}</p>
          //   </div>,
          //   "lg",
          //   "/user-auth/login"
          // );

          // const decDetails = decrypt(data.data);
          // setUser(decDetails.token);
          // localStorage.setItem("token", decDetails.token);
          // localStorage.setItem("session", decDetails.session_id);
          // navigate("/activate-key");
          sessionStorage.setItem("phone_number", inputVales.phone_number);
          navigate("/user-auth/verify-phone");
        } else {
          setInputValues({
            ...inputVales,
            error: formatMessage(data.message),
            notification: "",
            loading: false,
          });
        }
      })
      .catch((error) => {
        setInputValues({
          ...inputVales,
          error: formatMessage(
            error.response.data.message ?? "someThingWentWrong"
          ),
          loading: false,
          notification: "",
        });
      });
  }
  const responseMessage = (response) => {
    axios
      .get(
        `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${response.access_token}`,
        {
          headers: {
            Authorization: `Bearer ${response.access_token}`,
            Accept: "application/json",
          },
        }
      )
      .then((res) => {
        showModal(
          <GoogleRegister
            values={{
              ...inputVales,
              firstName: res.data.given_name,
              lastName: res.data.family_name,
              email: res.data.email,
              error: "",
            }}
          />,
          "sm"
        );
      })
      .catch((err) => console.log(err));
  };
  const login = useGoogleLogin({
    onSuccess: responseMessage,
    onError: () => {
      setInputValues({
        ...inputVales,
        error: formatMessage("someThingWentWrong"),
        loading: false,
        notification: "",
      });
    },
  });

  return (
    <>
      <Loader open={tenantLoading || tenant === "app" || inputVales.loading} position="portal" />
      <div 
        className="h-dvh w-dvw flex items-center relative overflow-hidden" 
        style={{
          background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
        }}
        dir={dir}
      >
        {/* Minimal Grid Background */}
        <div 
          className="absolute inset-0 opacity-100"
          style={{
            backgroundImage: `
              linear-gradient(rgba(255, 255, 255, 0.17) 1px, transparent 1.5px),
              linear-gradient(90deg, rgba(255, 255, 255, 0.41) 1px, transparent 1.5px)
            `,
            backgroundSize: '20px 20px'
          }}
        />
        
        {/* Header section - Logo/Brand at top */}
        <div className="absolute top-6 left-0 right-0 z-10 flex items-center justify-center">
          {tenantDetail?.profile_image ? (
            <a 
              href={tenantDetail?.website} 
              target="_blank" 
              rel="noreferrer"
              className="transition-transform hover:scale-105"
            >
              <img
                src={tenantDetail?.profile_image}
                alt={tenantDetail?.institution_title}
                className="w-32 md:w-48 object-contain h-16 md:h-20"
              />
            </a>
          ) : (
            <div className="w-32 md:w-48 h-16 md:h-20 bg-gray-100 rounded-lg flex items-center justify-center">
              <span className="text-gray-400 text-sm">Logo</span>
            </div>
          )}
        </div>
        
        <div className="w-full h-full flex flex-col items-center justify-center p-6">
          
          {/* Glassmorphic Card Container - Centered */}
          <div className="flex items-center justify-center w-full max-w-md">
            <div 
              className="w-full bg-white/25 backdrop-blur-xl rounded-2xl border border-white/30 shadow-2xl p-8"
              style={{
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.4)'
              }}
            >
              <div
                className="flex flex-col w-full"
                dir={dir}
              >
                <h1 className="text-[#09244B] text-2xl font-bold text-center mb-6">
                  {t("registerPageTitle")}
                </h1>
                {signUpWithEmail ? (
                  <>
                    <div className="mb-4">
                      {inputVales.error && (
                        <p className="text-red-500 text-xs italic">
                          {inputVales.error ?? t("someThingWentWrong")}
                        </p>
                      )}

                      {inputVales.notification && (
                        <p className="text-green-500 text-xs italic">
                          {inputVales.notification || ""}
                        </p>
                      )}
                    </div>
                    
                    {/* Name Fields - Responsive Layout */}
                    <div className="flex flex-col sm:flex-row gap-4 mb-4">
                      <Input
                        id="first_name"
                        type="text"
                        placeholder={t("signupPageFirstNamePlaceholder")}
                        value={inputVales.firstName}
                        onChange={(e) => {
                          const sanitized = sanitizeTextInput(e.target.value);
                          const validation = validateTextareaInput(sanitized, 50);
                          setInputValues({
                            ...inputVales,
                            firstName: validation.sanitized,
                          });
                        }}
                        className="text-base py-1 flex-1"
                        maxLength={50}
                      />
                      <Input
                        id="last_name"
                        type="text"
                        placeholder={t("signupPageLastNamePlaceholder")}
                        value={inputVales.lastName}
                        onChange={(e) => {
                          const sanitized = sanitizeTextInput(e.target.value);
                          const validation = validateTextareaInput(sanitized, 50);
                          setInputValues({
                            ...inputVales,
                            lastName: validation.sanitized,
                          });
                        }}
                        className="text-base py-1 flex-1"
                        maxLength={50}
                      />
                    </div>
                  {/*

                  <Input
                    id="email"
                    type="email"
                    placeholder={t("signupPageEmailPlaceholder")}
                    value={inputVales.email}
                    onChange={(e) =>
                      setInputValues({ ...inputVales, email: e.target.value })
                    }
                    className="text-base py-1"
                    dir="ltr"
                  />
                  */}
                    {/* Phone Input */}
                    <div className="mb-4" dir="ltr">
                      <Input
                        dir="ltr"
                        id="phone"
                        type="number"
                        addonBefore="+972"
                        placeholder={"05XXXXXXXX"}
                        value={inputVales.phone_number}
                        onChange={(e) => {
                          // Remove any non-digit characters for security
                          const sanitized = e.target.value.replace(/\D/g, '');
                          const regex = /^\d{0,10}$/;
                          if (
                            regex.test(sanitized) &&
                            !sanitized.includes("-")
                          ) {
                            setInputValues({
                              ...inputVales,
                              phone_number: sanitized,
                            });
                          }
                        }}
                        className="phone-input text-base py-1"
                        size="large"
                      />
                    </div>
                  {/* <Input.Password
                    id="password"
                    type="password"
                    placeholder={t("signupPagePasswordPlaceholder")}
                    value={inputVales.password}
                    onChange={(e) =>
                      setInputValues({
                        ...inputVales,
                        password: e.target.value,
                      })
                    }
                    note={t("passwordRequirments")}
                    className="text-base py-1"
                  />
                  <Input.Password
                    id="confirm_password"
                    type="password"
                    placeholder={t("signupPageConfirmPasswordPlaceholder")}
                    value={inputVales.confirmPassword}
                    onChange={(e) =>
                      setInputValues({
                        ...inputVales,
                        confirmPassword: e.target.value,
                      })
                    }
                    className="text-base py-1"
                  /> */}
                  {/* <p dir={dir} className="text-[11px] md:text-xs text-gray-400" dangerouslySetInnerHTML={{
                    __html: t("passwordInstructionsForSignUp")
                  }}></p> */}
                    {/* Terms and Privacy Checkbox */}
                    <div className="mb-4">
                      <div
                        className="flex items-start gap-3"
                        dir={dir}
                      >
                        <input
                          type="checkbox"
                          id="privacy"
                          checked={inputVales.termsAndPolicyChecked}
                          onChange={(event) => {
                            setInputValues({
                              ...inputVales,
                              termsAndPolicyChecked: event.target.checked,
                            });
                          }}
                          className="cursor-pointer mt-1 flex-shrink-0"
                        />
                        <label
                          className="text-[11px] md:text-xs leading-relaxed cursor-pointer"
                          onClick={() => {
                            setInputValues({
                              ...inputVales,
                              termsAndPolicyChecked:
                                !inputVales.termsAndPolicyChecked,
                            });
                          }}
                        >
                          {t("termsAndPrivacy.IAgree")}&nbsp;
                          <span
                            className="underline cursor-pointer hover:text-blue-600 transition-colors"
                            onClick={(e) => {
                              e.stopPropagation();
                              showModal(
                                <RenderTermsAndPrivacy url="https://link.nexme.ai/terms" />,
                                "md"
                              );
                            }}
                          >
                            {t("termsAndPrivacy.TermsFfUse")}
                          </span>
                          &nbsp;
                          {t("termsAndPrivacy.and")}&nbsp;
                          <span
                            className="underline cursor-pointer hover:text-blue-600 transition-colors"
                            onClick={(e) => {
                              e.stopPropagation();
                              showModal(
                                <RenderTermsAndPrivacy url="https://link.nexme.ai/privacy" />,
                                "md"
                              );
                            }}
                          >
                            {t("termsAndPrivacy.privacyPolicy")}
                          </span>
                          &nbsp;
                          {t("termsAndPrivacy.reachByConsultant")}
                        </label>
                      </div>
                    </div>

                    
                    {/* Register Button */}
                    <div className="mb-4">
                      <OutlinedButton
                        onClick={handleSubmit}
                        disabled={
                          !inputVales.firstName.trim() ||
                          !inputVales.lastName.trim() ||
                          !inputVales.phone_number ||
                          inputVales.phone_number.length !== 10 ||
                          !inputVales.termsAndPolicyChecked
                        }
                        className="bg-gradient-to-r from-amber-500 to-yellow-500 hover:from-amber-600 hover:to-yellow-600 text-gray-900 py-3 w-full font-semibold transition-all duration-200 flex items-center justify-center rounded-xl shadow-lg hover:shadow-xl disabled:!bg-gray-300 disabled:!from-gray-300 disabled:!to-gray-400 disabled:text-gray-500 disabled:cursor-not-allowed disabled:shadow-none"
                      >
                        {t("registerButton")}
                      </OutlinedButton>
                    </div>
                  </>
                ) : (
                  <button
                    onClick={() => setSignupWithEmail(true)}
                    className="flex items-center justify-center gap-1 border-2 border-[#818181] text-[#505050] text-base font-medium rounded-lg w-full px-5 py-2 "
                  >
                    <PhoneIcon /> &nbsp; {t("signUpWithPhoneButton")}
                  </button>
                )}
                {/* Google Sign Up - Only show when not in email form */}
                {!signUpWithEmail && (
                  <>
                    <Divider variant="solid">{t("dividerOR")}</Divider>
                    <button
                      onClick={login}
                      className="flex items-center justify-center gap-2 border-2 border-blue-500 text-blue-500 text-base font-medium rounded-lg w-full px-5 py-2 mb-4"
                    >
                      <Google />
                      {t("registerWithGoogle")}
                    </button>
                  </>
                )}

                
                {/* Navigation Links */}
                <div className="flex flex-col items-center justify-center w-full">
                  {signUpWithEmail ? (
                    <button
                      className="underline capitalize w-fit mx-auto text-gray-600 hover:text-gray-800 transition-colors"
                      onClick={() => {
                        setSignupWithEmail(false);
                      }}
                    >
                      {t("backButton")}
                    </button>
                  ) : (
                    <Link
                      className="text-gray-600 underline font-medium py-1 px-4 rounded-full focus:outline-none focus:shadow-outline text-sm text-center hover:text-gray-800 transition-colors"
                      to="/user-auth/login"
                    >
                      {t("signupPageAlreadyHaveAccountButton")}
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer section - Powered by at bottom */}
        <div className="absolute bottom-6 left-0 right-0 z-10 flex items-center justify-center gap-2 text-sm text-gray-600" dir="ltr">
          <span>Powered by</span>
          <img
            src={require("../../assets/logo/logo.png")}
            alt="Nexme"
            className="object-contain h-5 mb-1.5"
          />
        </div>
      </div>
    </>
  );
}
